import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

let _cache = null;
let _inflight = null;
let _cacheTime = 0;
const CACHE_TTL = 60000;

/** Fetches the admin-managed client list (logo + name + url + order). */
export function useClients() {
  const [clients, setClients] = useState(_cache || []);

  useEffect(() => {
    const now = Date.now();
    if (_cache && (now - _cacheTime) < CACHE_TTL) { setClients(_cache); return; }
    _cache = null;
    _inflight = null;
    if (!_inflight) {
      _inflight = axios.get(`${API}/clients`)
        .then((r) => { _cache = Array.isArray(r.data) ? r.data : []; _cacheTime = Date.now(); return _cache; })
        .catch(() => { _cache = []; _cacheTime = Date.now(); return _cache; });
    }
    _inflight.then((data) => setClients(data));
  }, []);

  return clients;
}
